import { useState, useEffect } from 'react';
import { UserProfile, userProfilesStateService } from '../services/UserProfilesStateService';

export function useUserProfilesState() {
  const service = userProfilesStateService;
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Initial load
  useEffect(() => {
    const loadProfiles = async () => {
      setIsLoading(true);
      try {
        const profile = await service.getUserProfile();
        setUserProfile(profile);
      } catch (error) {
        console.error("Error loading user profiles:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadProfiles();

    // Subscribe to updates
    return service.subscribe((newUserProfile) => {
      setUserProfile(newUserProfile);
    });
  }, []);

  // Wrapper to handle the async refresh
  const refreshUserProfile = async () => {
    setIsLoading(true);
    try {
      await service.refreshUserProfile();
    } catch (error) {
      console.error("Error refreshing user profiles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    userProfile,
    isLoading,
    refreshUserProfile
  };
} 